module.exports = __webpack_public_path__ + "img/thumb-photogrid.aff29789.png";